import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Loader } from 'rsuite';
import {
  getCampaignLandingData,
  getCampaignElements,
  getReadyToSubmit,
  getIsSubmittingForProcessing,
  submitCampaignSubmission,
  getIsCampaignPreview,
  previewSubmitCampaignSubmission,
  getCampaignBanner,
  getUseCampaignBanner,
  getCampaignBrandFontColor,
  getCampaignLanguage,
  getDisableSubmitButton,
} from '../../redux/modules/campaignLandingPage';
import styles from './SubmitResponseButton.module.less';
import { useVpSnackbar } from '../../vp-ui';
import { StyledBrandingButton, StyledOutlineBrandingButton } from './styles';
import { getTranslation } from '../../translations/dictionary';

const buildPayload = (campaignLandingData, campaignElements) => {
  const elementsAsArray = Object.values(campaignElements);

  return {
    campaignId: campaignLandingData.campaignId,
    responses: elementsAsArray.map((el) => ({
      campaignElementId: el.id,
      value: el.value,
      mediaSubmissionId: el?.mediaSubmissionId,
      selected: el.selected,
      attachment: el?.attachment
    }))
  };
};

const SubmitResponseButton = ({
  _submitCampaignSubmission,
  readyToSubmit,
  campaignLandingData,
  campaignElements,
  isSubmittingForProcessing,
  isPreview,
  _previewSubmitCampaignSubmission,
  backgroundColor = '',
  color = '',
  useBanner = false,
  language,
  disableSubmitButton
}) => {
  const submitLabel = getTranslation('submit', language) || 'Submit';

  const { addSnackbar } = useVpSnackbar();

  const handleSubmit = () => {
    if (isPreview) {
      _previewSubmitCampaignSubmission();

      addSnackbar({
        severity: 'warning',
        title: 'No Submission',
        message: `No submission has been sent because this is a preview of your Campaign. You can find the correct link under Share -> Copy Campaign Link, on your Campaign's editing page.`
      });
    } else {
      const payload = buildPayload(campaignLandingData, campaignElements);
      _submitCampaignSubmission(payload);
    }
  };

  const useCustomeStyle = useBanner && backgroundColor && color;
  const isWhitePrimaryColor = backgroundColor === 'rgb(255 255 255 / 1)';

  const buttonProps = {
    component: 'label',
    variant: isWhitePrimaryColor ? 'outlined' : 'contained',
    disabled: disableSubmitButton || isPreview || !readyToSubmit,
    id: 'vpSubmitResponseButton',
    backgroundColor: backgroundColor,
    fontColor: color,
    custom: useCustomeStyle,
    onClick: handleSubmit,
    sx: { width: '200px', mt: '25px' }
  };

  return isWhitePrimaryColor ? (
    <StyledOutlineBrandingButton data-testid="submitResponse" {...buttonProps}>
      {isSubmittingForProcessing ? <Loader className={styles.vpLoadingSpinner} /> : submitLabel}
    </StyledOutlineBrandingButton>
  ) : (
    <StyledBrandingButton data-testid="submitResponse" {...buttonProps}>
      {isSubmittingForProcessing ? <Loader className={styles.vpLoadingSpinner} /> : submitLabel}
    </StyledBrandingButton>
  );
};

SubmitResponseButton.propTypes = {
  _submitCampaignSubmission: PropTypes.func,
  readyToSubmit: PropTypes.bool,
  campaignLandingData: PropTypes.object,
  campaignElements: PropTypes.object,
  isSubmittingForProcessing: PropTypes.bool,
  isPreview: PropTypes.bool,
  _previewSubmitCampaignSubmission: PropTypes.func,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  useBanner: PropTypes.bool,
  language: PropTypes.string
};

const mapStateToProps = (state) => ({
  readyToSubmit: getReadyToSubmit(state),
  campaignLandingData: getCampaignLandingData(state),
  campaignElements: getCampaignElements(state),
  isSubmittingForProcessing: getIsSubmittingForProcessing(state),
  isPreview: getIsCampaignPreview(state),
  backgroundColor: getCampaignBanner(state),
  useBanner: getUseCampaignBanner(state),
  color: getCampaignBrandFontColor(state),
  language: getCampaignLanguage(state),
  disableSubmitButton: getDisableSubmitButton(state)
});

const mapDispatchToProps = {
  _submitCampaignSubmission: submitCampaignSubmission,
  _previewSubmitCampaignSubmission: previewSubmitCampaignSubmission
};

export default connect(mapStateToProps, mapDispatchToProps)(SubmitResponseButton);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/SubmitResponseButton.jsx